import React, { useState, useEffect } from "react"

//Components
import CherryspinsFacebookHeader from "../components/CherryspinsFacebookHeader";
import CherryspinsLoader from "../components/CherryspinsLoader";

import light from '../images/cherry-spins/light.png';
import bonusOffer from '../images/cherry-spins/retargeting/bonus-offer.png';

import styles from '../components/OroSlots.module.css';
import '../components/cherryspinsSlotsGame.scss';
import './cherryspinsFacebook.scss';
import './cherryspinsFacebookRetarget.scss';

export default function CherryspinsFacebookRetarget() {

    useEffect(() => { });

    const playNow = () => {
        try {
            window.FbEvents.Contact().then(data => {
                console.log(data)
                window.location.href = 'https://cherryspins.com/ca-en/?register&tsource=facebook'
            });
        } catch (error) {
            console.log(error)
            window.location.href = 'https://cherryspins.com/ca-en/?register&tsource=facebook'
        }
    }

    return (
        <section className="cherry-spins-facebook retarget" >
            <div className="page-wrapper">

                <CherryspinsFacebookHeader />

                <section className={styles.slotsSection}>
                    <div className={styles.slotWrapper}>

                        {/* <div className="cherry-spins-facebook-banner">
                            <img className='facebook-banner-image' src={img} alt="" />
                        </div> */}

                        <div className="container-fluid h-100" style={{ position: 'relative', zIndex: '2' }}>
                            <div className="row h-100 align-items-center">
                                <div className="col-12 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3 facebook-offer-container facebook-offer-retargeting">
                                    <img src={light} className="light-background" />

                                    {/* <p className="facebook-offer-surtitle">NO FEE REQUIRED!</p>
                                    <h1 className="facebook-offer-title">10 ROUNDS FOR FREE!</h1> */}

                                    <div className="facebook-offer-wrapper">

                                        <img src={bonusOffer} className="facebook-offer-board" />
                                        {/* <p className="facebook-offer-description">Amazing bonuses<br />up to 200%!</p> */}

                                    </div>

                                    {/* <a href="https://cherryspins.com/ca-en?register" className="btn btn-primary main-cta cta-large facebook-offer-button pulse-button">PLAY NOW!</a> */}

                                    <button className="btn btn-primary main-cta cta-large facebook-offer-button pulse-button" onClick={playNow}>PLAY NOW!</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <CherryspinsLoader />
            </div>
        </section>
    )
}